import styled from 'styled-components';
import { ButtonBack, ButtonNext, CarouselProvider } from 'pure-react-carousel';

export const CarouselWrapper = styled(CarouselProvider)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
 
`;
export const SliderWrapper = styled.div`

`;

export const ButtonBackWrapper = styled(ButtonBack)`
  border: none;
  background: none;
  padding: 11px 20px;
  cursor: pointer;
`;

export const ButtonNextWrapper = styled(ButtonNext)`
  border: none;
  background: none;
  padding: 11px 20px;
  cursor: pointer;
`;

export const DotWrapper = styled.div`
   display: flex;
  align-items: center;
  justify-content: center;

  .dot-group {
    display: flex;
    align-items: center;
    justify-content: center;

    .carousel__dot {
      width: 8px;
      height: 8px;
      border: none;
      border-radius: 50%;
      margin: 0 4px;
      padding: 0;
      background-color: #c3c4ca;
      cursor: pointer;
    }

    .carousel__dot--selected {
      width: 16px;
      height: 8px;
      border-radius: 10px;
      background-color: #6267a1;
      transition: background 0.4s ease;
    }
  }
`;